import React from 'react';
import './styles.css';

const Header = () => (
  <header className='home-header'>
    <h2>Hello Travelers</h2>
    <h1>
      <span>“</span> Blog <span>”</span>
    </h1>
    <p>
      Awesome place to make oneself <br /> Find travel blogs which can be both beautiful and informative.
    </p>
  </header>
);

export default Header;
